import { Habit, Instance } from "src/database/types";

export interface DayReport {
  disabled: boolean;
  completed: boolean;
}

export interface WeekReport {
  total: number;
  completed: number;
}

export const GoalSummary = {
  summariseHabit,
  sumWeekReports,
};

function sumWeekReports(summaries: WeekReport[]): WeekReport {
  const aggregate: WeekReport = { total: 0, completed: 0 };
  for (const summary of summaries) {
    aggregate.total += summary.total;
    aggregate.completed += summary.completed;
  }

  return aggregate;
}

function summariseHabit(
  habit: Habit,
  instancesByDate: Instance[][],
): { dayReports: DayReport[]; summary: WeekReport } {
  const dayReports: DayReport[] = [];
  for (const instances of instancesByDate) {
    const instance = instances.find((i) => i.templateId === habit.id);
    if (!instance) {
      dayReports.push({ disabled: true, completed: false });
      continue;
    }
    dayReports.push({
      disabled: instance.disabled,
      completed: instance.completed,
    });
  }

  // tally total and completed habits
  const summary = { total: 0, completed: 0 };
  for (const report of dayReports) {
    if (report.disabled) continue;
    summary.total += 1;
    if (report.completed) {
      summary.completed += 1;
    }
  }

  return { dayReports, summary };
}
